<template>
    <!--
        Uses Inline Tab Secion Header Component from Tailwind UI
        https://tailwindui.com/components/application-ui/headings/section-headings#component-276936aa601c0ab9e065e66f22b6e6c0
     -->
    <div class="border-b border-gray-200">
        <div class="space-y-4 sm:flex sm:items-baseline sm:space-y-0 sm:space-x-10">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
                {{ name }}
            </h3>
            <div>
                <nav class="-mb-px flex space-x-8">
                    <span   v-for="header in headers"
                            @click="setCurrent(header.event)"
                            class="whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm
                                    leading-5 focus:outline-none cursor-pointer"

                            :class="(header.event === current)
                                    ? 'border-blue-500 text-blue-600 focus:text-blue-800 focus:border-blue-700'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:text-gray-300 ' +
                                      'focus:text-gray-700 focus:border-gray-300'"
                            aria-current="page">
                        {{ header.text }}
                    </span>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InlineTabHeader",
        mixins: [],
        components: {},
        props: {
            name: {
                type: String,
                required: true,
            },
            headers: {
                type: Array,
                default() {
                    return [{
                        text: "No Headers",
                        event: 'no-headers'
                    }]
                },
            },
            current: {
                type: String,
                default: null,
            },
        },
        data() {
            return {

            }
        },
        mounted() {
            this.$emit('update:current', this.current ?? this.headers[0].event)
        },
        methods: {
            setCurrent(event) {
                this.$emit('update:current', event)
                this.$emit(event)
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>